import axios from "axios";
import { baseUrl } from "./constants";

// Interfaces
export interface ChatSessionSummary {
  source_entity: string;
  username: string;
  user_email: string;
  uid: string;
  name: string;
  created: string;
  has_trip_summary: boolean;
  submitted: boolean;
  is_favorite: boolean;
}

export interface GetChatSessionsResponse {
  sessions: ChatSessionSummary[];
}

// Axios request
export async function getChatSessions(username: string): Promise<GetChatSessionsResponse> {
  const response = await axios.get<GetChatSessionsResponse>(
    `${baseUrl}/api/v1/quotation-request-chat/sessions/${username}`,
  );
  return response.data;
}
